import moment from "moment";

// Number of ISO weeks in one ISO period. Mirrors the backend IsoPeriodService constant.
export const isoWeeksPerPeriod = 4;

// ISO periods are always 1..13. A 53-week ISO year folds its extra week into period 13 (which then
// spans five weeks). Mirrors the backend IsoPeriodService — without clamping to this, week 53
// resolves to a non-existent period 14.
export const lastPeriodOfYear = 13;

// Snaps a date to the first day (Monday) of the four-week ISO period that contains it.
// Mirrors the backend IsoPeriodService.GetIsoPeriod so the front-end anchor and the API agree.
export default function getIsoPeriodStart(date) {
    const isoWeek = moment(date).isoWeek();
    const isoYear = moment(date).isoWeekYear();
    const period = Math.min(Math.ceil(isoWeek / isoWeeksPerPeriod), lastPeriodOfYear);
    const startWeek = (period - 1) * isoWeeksPerPeriod + 1;
    return moment().isoWeekYear(isoYear).isoWeek(startWeek).startOf("isoWeek");
}
